import { render } from "./EditarEquipos.vue?vue&type=template&id=71aaf65f"
import script from "./EditarEquipos.vue?vue&type=script&lang=js"
export * from "./EditarEquipos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__